import { boolean } from "../boolean";
import { lazy } from "../lazy";
import { object } from "../object";
import { string } from "../string";
import { array } from "../Type";
export var Flaw;
(function (Flaw) {
    Flaw.type = object({
        message: string().optional(),
        isFlaw: boolean().optional(),
        property: string().optional(),
        type: string(),
        flaws: array(lazy(() => Flaw.type)).optional(),
        condition: string().optional(),
    }, "Flaw");
    Flaw.is = Flaw.type.is;
    Flaw.flaw = Flaw.type.flaw;
})(Flaw || (Flaw = {}));
//# sourceMappingURL=index.js.map